import * as React from "react";
import {defineMessages, injectIntl} from "react-intl";
import {Warning} from "../common/model";
import {createDeleteButtonComponent} from "../common/ui/DeleteButton";
import {AOINotificationArea} from "./model";
import InjectedIntlProps = ReactIntl.InjectedIntlProps;

const DeleteButtonComponent = createDeleteButtonComponent();

interface DeleteDataButtonProps {
    data: AOINotificationArea[];
    disabled: boolean;
    onDeleteSuccess: () => void;
    onDeleteError?: () => void;
    onDeleteWarnings: () => void;
    onDelete: () => Promise<Warning[]>;
    onCloseWarnings?: () => void;
    detail?: boolean;
}

const MESSAGES = defineMessages({
    removeAOIHeader: {
        id: "studio.aoi.delete-aoi-button.delete-aoi-header",
        defaultMessage: "Remove {Amount} AOIs",
    },
    removeSingleAOIHeader: {
        id: "studio.aoi.delete-aoi-button.delete-single-aoi-header",
        defaultMessage: "Remove AOI {Title}",
    },
    removeAOIBody: {
        id: "studio.aoi.delete-aoi-button.remove-aoi-body",
        defaultMessage: "Are you sure you want to continue?",
    },
    whileRemoveAOI: {
        id: "studio.aoi.delete-aoi-button.while-remove-aoi",
        defaultMessage: "Removing AOI...",
    },
    deleteButton: {
        id: "studio.aoi.delete-aoi-button.delete-button",
        defaultMessage: "Remove AOI",
    },
    deleteConfirmationBody:{
        id: "studio.data.delete-data-button.confirmation-body",
        defaultMessage: "Are you sure you want to continue?",
    },
    removeStylesSuccess: {
        id: "studio.aoi.delete-aoi-button.remove-success",
        defaultMessage: "AOI successfully removed",
    },
    tooltipMessageNoSelection: {
        id: "studio.aoi.delete-aoi-button.no-selection-tooltip",
        defaultMessage: "Select AOI from the list below",
    },
    tooltipMessageOneItemSelection: {
        id: "studio.aoi.delete-aoi-button.permission-error",
        defaultMessage: "You don't have permission to delete the AOI",
    },
    tooltipMessageItemsSelection: {
        id: "studio.aoi.delete-aoi-button.permission-error",
        defaultMessage: "You don't have permission to delete the AOI",
    },
    buttonTitle: {
        id: "studio.aoi.delete-aoi-button.delete-aoi",
        defaultMessage: "Remove AOI",
    },
    buttonTitleDetail: {
        id: "studio.aoi.delete-aoi-button.remove",
        defaultMessage: "Remove",
    },
});

class DeleteDataButtonComponent extends React.Component<DeleteDataButtonProps & InjectedIntlProps> {

    render() {
        const {
            data,
            onDeleteSuccess,
            onDeleteError,
            onDeleteWarnings,
            onCloseWarnings,
            intl,
            disabled,
            detail
        } = this.props;
        let headerText = intl.formatMessage(MESSAGES.removeAOIHeader, {Amount: data.length});
        let buttonTitle = intl.formatMessage(MESSAGES.buttonTitle);
        if (data && data.length === 1) {
            if (detail) {
                buttonTitle = intl.formatMessage(MESSAGES.buttonTitleDetail);
            }
            headerText = intl.formatMessage(MESSAGES.removeSingleAOIHeader, {Title: data[0].name});
        }
        const tooltipDisabled = this.getTooltipDisabled();

        return <DeleteButtonComponent
            intl={this.props.intl}
            disabled={disabled}
            onDelete={this.props.onDelete}
            onDeleteSuccess={onDeleteSuccess}
            onDeleteError={onDeleteError}
            onDeleteWarnings={onDeleteWarnings}
            onCloseWarnings={onCloseWarnings}
            dialogTitle={headerText}
            buttonTitle={buttonTitle}
            detail={detail}
            tooltipDisabled={tooltipDisabled}
            successMessage={intl.formatMessage(MESSAGES.removeStylesSuccess)}
            executingMessage={intl.formatMessage(MESSAGES.whileRemoveAOI)}
            confirmButtonText={intl.formatMessage(MESSAGES.deleteButton)}
            renderConfirmation={() => {
                return (
                    <div>
                        {intl.formatMessage(MESSAGES.deleteConfirmationBody)}
                    </div>
                );
            }}
        />;
    }

    private getTooltipDisabled() {
        const {data, intl} = this.props;
        const noData = !data || data.length === 0;

        if (noData) {
            return intl.formatMessage(MESSAGES.tooltipMessageNoSelection);
        }
        if (data.length === 1) {
            return intl.formatMessage(MESSAGES.tooltipMessageOneItemSelection);
        }
        return intl.formatMessage(MESSAGES.tooltipMessageItemsSelection);
    }

}

export const DeleteAOIButton = injectIntl(DeleteDataButtonComponent);